<div class="resend-sms d-flex flex-column align-items-center">
  <div class="resend-sms-body">
    <div *ngIf="showSignMessage" class="resend-sms-content">
      <p class="resend-sms__text text-center">
        {{ (verificationType === VerificationTypeEnum.SMS ? 'YOU_DONT_INPUT_CODE_FROM_SMS' : 'YOU_DONT_INPUT_LAST_NUMBER') | translate }} {{
        'YOU_CAN_USE' | translate }}
      </p>
    </div>
    <div *ngIf="showAuthMessage" class="resend-sms-content">
      <p *ngIf="!timeOut && showPhone" [innerHtml]="'AUTH.SHORT_TEXT' | translate" class="resend-sms__text text-center"></p>
      <p *ngIf="timeOut || !showPhone" class="resend-sms__text text-center">{{ 'CONFIRM.PHONE' | translate }}</p>
    </div>
  </div>
  <div
    [class]="buttonPosition"
    [ngClass]="
        showPhone ? 'justify-content-md-between' : 'justify-content-md-center'
      "
    class="resend-sms-footer w-100 text-center d-flex"
  >
    <ng-container *ngIf="showIVR">
      <app-button
        (clickEvent)="resend(VerificationTypeEnum.IVR)"
        [label]="'BUTTON.REPEAT_PHONE' | translate"
        class="w-100"
        classes="fs-15 fw-bold mb-md-0"
        color="primary"
        size="w100"
        type="button"
      >
      </app-button>
    </ng-container>
    <ng-container *ngIf="showPhone">
      <app-button
        (clickEvent)="resend(VerificationTypeEnum.PHONE)"
        [label]="'BUTTON.REPEAT_PHONE' | translate"
        class="w-100"
        classes="fs-15 fw-bold mb-md-0"
        color="primary"
        size="w100"
        type="button"
      >
      </app-button>
    </ng-container>
    <app-button
      (clickEvent)="resend(VerificationTypeEnum.SMS)"
      [label]="(otherResendSmsLabel ?? (resendEvent === VerificationTypeEnum.SMS ? 'BUTTON.RESEND_SMS_AGAIN' : 'BUTTON.REPEAT_SMS')) | translate"
      class="w-100"
      classes="fs-15 fw-bold"
      color="inline"
      size="w100"
      type="button"
    >
    </app-button>
    <app-button
      (clickEvent)="resend(VerificationTypeEnum.VIBER)"
      [img]="{url: 'assets/img/viber.png', height: '24px', width: '24px'}"
      [label]="('BUTTON.SEND_VIBER' | translate)"
      class="w-100"
      classes="fs-15 fw-bold"
      color="viber"
      size="w100"
      type="button"
    >
    </app-button>
  </div>
</div>
